import { BaseEntity } from "yt-ng-framework";

export class AkciznaRobaTipPakovanja extends BaseEntity {

    constructor() {
        super();
    }

    AkciznaRobaID: string = null;
    Naziv: string = null;
    Kategorija: string = null;

    Deserialize(input: any) {
        this.ID = input.ID;
        this.AkciznaRobaID = input.AkciznaRobaID;
        this.Naziv = input.Naziv;
        this.Kategorija = input.Kategorija;
        return this;
    }

    Serialize(input: AkciznaRobaTipPakovanja) {
        return input;
    }
}
